// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClientUpdateNotice__container___OYGAF {
    position: fixed;
    top: 12px;
    left: 50%;
    z-index: 30000;
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: calc(100vw - 24px);
    padding: 9px 12px;
    transform: translateX(-50%);
    color: rgba(246, 239, 218, 0.96);
    background: rgba(22, 18, 16, 0.96);
    border: 1px solid rgba(190, 151, 76, 0.72);
    border-radius: 8px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.48),
        0 0 10px rgba(190, 151, 76, 0.16);
    font-family: "Share Tech Mono", monospace;
    font-size: 13px;
    white-space: nowrap;
    animation: ClientUpdateNotice__fadeIn___ijjIo 1.5s ease-out both;
}

.ClientUpdateNotice__container___OYGAF button {
    padding: 4px 9px;
    color: rgba(255, 239, 184, 0.98);
    background: rgba(173, 139, 62, 0.18);
    border: 1px solid rgba(190, 151, 76, 0.56);
    border-radius: 4px;
    cursor: pointer;
    font: inherit;
}

.ClientUpdateNotice__container___OYGAF button:hover,
.ClientUpdateNotice__container___OYGAF button:focus-visible {
    color: #fff8d8;
    background: rgba(173, 139, 62, 0.34);
    outline: none;
}

@keyframes ClientUpdateNotice__fadeIn___ijjIo {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .ClientUpdateNotice__container___OYGAF {
        animation: none;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClientUpdateNotice__container___OYGAF`,
	"fadeIn": `ClientUpdateNotice__fadeIn___ijjIo`
};
module.exports = ___CSS_LOADER_EXPORT___;
